<template>
  <div>
    <p class="modify" @click="showDialog">
      <i class="las la-lock"></i>修改密码
    </p>

    <el-dialog
      title="修改密码"
      :visible.sync="dialogTableVisible"
      width="550px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        :model="form"
        :rules="rules"
        v-loading="loading"
        autocomplete="off"
        ref="ruleForm"
      >
        <el-form-item
          label="手机号"
          :label-width="formLabelWidth"
          class="is-required"
          prop="phone"
        >
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号"
            @input="changePhone"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="验证码"
          :label-width="formLabelWidth"
          class="is-required"
          prop="verification"
        >
          <el-input
            v-model="form.verification"
            autocomplete="off"
            placeholder="请输入验证码"
          >
            <el-button
              slot="append"
              :class="{
                activation: activation,
              }"
              :disabled="!activation"
              @click="getVerificationCode"
              >{{ verificationText }}</el-button
            >
          </el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          :label-width="formLabelWidth"
          class="is-required"
          prop="password"
        >
          <el-input
            v-model="form.password"
            :type="passw"
            autocomplete="new-password"
            placeholder="新密码包含大小写字母、数字、特殊字符，至少8个字符"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-view"
              @click="showPass"
            ></i>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSmsCaptchaResult, postSmsRstPw } from "@/api/api";
import _ from "lodash";
export default {
  name: "change-password",
  components: {},
  data() {
    var validatePhone = (rule, value, callback) => {
      var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      var result = re.test(value);
      if (!result) {
        callback(new Error("请输入正确的手机号"));
        return false; //若手机号码格式不正确则返回false
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (
        !/(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,}/.test(value)
      ) {
        callback(
          new Error("密码必须包含大小写字母、数字、特殊字符，至少8个字符")
        );
        return false;
      } else {
        callback();
      }
    };
    return {
      dialogTableVisible: false,
      formLabelWidth: "80px",
      verificationText: "获取验证码",
      activation: false,
      passw: "password",
      nowTime: 120,
      loading: false,
      form: {
        phone: "",
        password: "",
        verification: "",
      },
      rules: {
        phone: [
          {
            validator: validatePhone,
            trigger: "change",
            message: "请输入正确的手机号",
          },
        ],
        password: [
          {
            validator: validatePassword,
            trigger: "change",
          },
        ],
        verification: [
          { required: true, message: "请输入验证码", trigger: "change" },
        ],
      },
    };
  },

  methods: {
    showDialog() {
      this.dialogTableVisible = true;
      this.init();
    },

    getVerificationCode: _.debounce(function(e) {
      let data = {
        account: "填充值，以便能通过后端接口验证。",
        password: "填充值，以便能通过后端接口验证。",
        loginType: "phone",
        phone: Number(this.form.phone),
        phoneCode: "填充值，以便能通过后端接口验证。",
      };
      getSmsCaptchaResult(data)
        .then((res) => {
          if (res.data.success && res.data.code === 204) {
            this.$message({
              message: "短信已发送",
              type: "success",
            });
            this.activation = false;
            let timer;
            if (this.nowTime == 120) {
              let countDown = () => {
                this.nowTime -= 1;
                this.verificationText = this.nowTime + "s";
                if (this.nowTime == 0) {
                  this.nowTime = 120;
                  this.verificationText = "获取验证码";
                  clearInterval(timer);
                  timer = null;
                  this.changePhone(this.form.phone);
                }
              };
              timer = setInterval(countDown, 1000);
              this.verificationText = this.nowTime + "s";
            }
          } else {
            this.$message.error(JSON.stringify(res.data.message));
          }
        })
        .catch((err) => {
          this.$message.error("短信发送失败，请稍后再试或者联系管理员");
        });
    }, 500),
    dialogFormVisible() {},
    changePhone(e) {
      var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      var result = re.test(e);
      if (!result || this.nowTime != 120) {
        this.activation = false;
      } else {
        this.activation = true;
      }
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            phone: this.form.phone,
            captchaCode: this.form.verification,
            password: this.form.password,
          };
          postSmsRstPw(data)
            .then((res) => {
              console.log(res.data);
              this.loading = false;
              let { code, data, message, success } = res.data;
              if (success || code == 200 || code == 204) {
                this.dialogTableVisible = false;
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              } else {
                this.$message.error(JSON.stringify(message));
              }
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
              this.$message.error("保存失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
    showPass() {
      if (this.passw == "password") {
        this.passw = "text";
      } else {
        this.passw = "password";
      }
    },
    init() {
      this.form = {
        phone: "",
        password: "",
        verification: "",
      };
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.modify {
  display: inline-block;
  cursor: pointer;
  &:hover {
    color: #2ab7ff;
  }
}
/deep/ .el-form-item__label {
  color: #606266 !important;
}
/deep/ .activation {
  border-radius: 0;
  color: #fff !important;
  background-color: #409eff !important;
  border-color: #409eff !important;
  height: 40px;
  &:hover {
    background: #66b1ff !important;
    border-color: #66b1ff !important;
    color: #fff !important;
  }
}
/deep/ .el-input-group__append button {
  width: 112px;
  &.is-disabled:hover {
    border-color: transparent;
    background-color: transparent;
    color: inherit;
  }
}

/deep/.el-input__icon.el-icon-view {
  cursor: pointer;
}
</style>
